:host {
  display: block;
  width: 100%;
  @include breakpoint(lg) {
    display: contents;
    width: auto;
  }
}

.spw-header-navigation-item {
  color: var(--spw-colors-support-grey-grey-900);
  font-size: 16px;
  font-weight: 700;
  background: white;

  :host([data-level='1']) & {
    ::slotted(a) {
      position: relative;
      padding: 24px 16px;
      font-size: 20px;
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 16px;
        width: calc(100% - 32px);
        height: 1px;
        background: var(--spw-colors-support-grey-grey-300);
      }
      @include breakpoint(lg) {
        padding: 20px 16px;
        font-size: 16px;
        border-bottom: 0;
        &:before {
          content: '';
          position: absolute;
          top: auto;
          bottom: 0;
          left: 16px;
          width: 0;
          height: 3px;
          background: var(--spw-ds-primary);
        }
      }
    }
    &:hover {
      @include breakpoint(lg) {
        ::slotted(spw-header-navigation-dropdown) {
          pointer-events: auto;
          opacity: 1;
          top: 100%;
          left: 16px;
          transition: opacity 0.1s ease-in;
        }
        ::slotted(a) {
          color: var(--spw-ds-primary) !important;
          &:before {
            width: calc(100% - 32px);
          }
        }
      }
    }

    &--has-subnav {
      ::slotted(a) {
        &:after {
          font-family: 'Font Awesome 6 Free';
          content: '\f054';
          font-size: 18px;
          @include breakpoint(lg) {
            content: '\f078';
            font-size: 14px;
          }
        }
      }
    }

    &--is-subnav-visible {
      ::slotted(spw-header-navigation-dropdown) {
        z-index: 10;
      }
      ::slotted(a) {
        &:after {
          content: '\f054';
          @include breakpoint(lg) {
            content: '\f078';
          }
        }
      }
    }
  }

  :host([data-level='2']) & {
    ::slotted(a) {
      padding: 12px 16px;
      font-weight: 400;
      font-size: 18px;
      @include breakpoint(lg) {
        padding: 20px;
        font-weight: 700;
        font-size: 16px;
      }
    }
    @include breakpoint(lg) {
      &:hover {
        ::slotted(spw-header-navigation-dropdown) {
          pointer-events: auto;
          opacity: 1;
          left: 100%;
          top: 0;
          transition: opacity 0.1s ease-in;
          z-index: 38;
        }
        ::slotted(a) {
          color: var(--spw-ds-primary) !important;
          background: var(--spw-colors-support-grey-grey-100);
          &:before {
            display: none;
          }
        }
      }
    }

    &--has-subnav {
      ::slotted(a) {
        &:after {
          font-family: 'Font Awesome 6 Free';
          content: '\f054';
          font-weight: 700;
        }
      }
    }

    &--is-subnav-visible {
      ::slotted(spw-header-navigation-dropdown) {
        z-index: 11;
      }
      ::slotted(a) {
        &:after {
          content: '\f054';
        }
      }
    }
  }

  :host([data-level='3']) & {
    ::slotted(a) {
      padding: 12px 16px;
      font-weight: 400;
      font-size: 16px;
      @include breakpoint(lg) {
        padding: 20px;
        font-weight: 700;
        font-size: 16px;
      }
    }
    ::slotted(a:hover) {
      @include breakpoint(lg) {
        color: var(--spw-ds-primary) !important;
      }
    }
    &--is-subnav-visible {
      ::slotted(spw-header-navigation-dropdown) {
        z-index: 12;
      }
    }
  }

  &--is-active {
    ::slotted(a) {
      color: var(--spw-ds-primary) !important;
    }
  }

  ::slotted(a) {
    display: inline-flex;
    position: relative;
    color: inherit;
    text-decoration: none;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    padding: 16px 0;
    @include breakpoint(lg) {
      padding: 16px;
    }
    &:before {
      @include breakpoint(lg) {
        content: '';
        transition: width 0.2s ease-in;
        bottom: 0;
        left: 16px;
        height: 5px;
        width: 0;
        position: absolute;
        background: var(--spw-ds-primary);
      }
    }
  }

  ::slotted(a:focus-visible) {
    outline: 3px solid var(--spw-ds-focus);
    outline-offset: -3px;
  }

  ::slotted(a:active) {
    color: var(--spw-ds-primary) !important;
  }

  ::slotted(spw-header-navigation-dropdown) {
    display: none;
    opacity: 0;
    @include breakpoint(lg) {
      display: block;
      pointer-events: none;
      opacity: 0;
      position: absolute;
      width: 320px;
      box-shadow: var(--spw-effect-elevation-8);
    }
  }

  &--is-subnav-visible {
    ::slotted(spw-header-navigation-dropdown) {
      @include under-breakpoint(lg) {
        display: block;
        opacity: 1;
        position: absolute;
        background: white;
        width: 100%;
        margin-top: 0;
        padding-top: 132px;
        top: 0;
        left: 0;
        min-height: 100%;
        overflow-y: auto;
      }
    }
  }
}

.spw-header-navigation-item__top {
  position: absolute;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  top: 0;
  left: 16px;
  height: 118px;
  z-index: 9999999;
  width: calc(100% - 32px);
  padding: 24px 0;
  background: white;
  border-bottom: 1px solid var(--spw-colors-support-grey-grey-300);

  &-back {
    gap: 8px;
    display: flex;
    justify-content: left;
    align-items: center;
    font-weight: 700;
    font-size: 14px;
    text-decoration: none;
    color: var(--spw-colors-support-grey-grey-900);
    span {
      text-decoration: underline;
    }
    spw-icon {
      font-size: 18px;
    }
  }

  &-title {
    a {
      font-size: 20px;
      font-weight: 700;
      text-decoration: underline;
      color: var(--spw-colors-support-grey-grey-900);
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  &--1 {
    :host([data-level-visible='1']) & {
      display: flex;
      @include breakpoint(lg) {
        display: none;
      }
    }
    :host([data-level-visible='2']) & {
      display: none;
    }
    :host([data-level-visible='3']) & {
      display: none;
    }
  }

  &--2 {
    :host([data-level-visible='1']) & {
      display: none;
    }
    :host([data-level-visible='2']) & {
      display: flex;
      @include breakpoint(lg) {
        display: none;
      }
    }
    :host([data-level-visible='3']) & {
      display: none;
    }
  }

  &--3 {
    :host([data-level-visible='1']) & {
      display: none;
    }
    :host([data-level-visible='2']) & {
      display: none;
    }
    :host([data-level-visible='3']) & {
      display: flex;
      @include breakpoint(lg) {
        display: none;
      }
    }
  }

  @include breakpoint(lg) {
    display: none;
  }
}
